if (!customElements.get('product-card-alt')) {
  class ProductCardAlt extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-variant-select]');
      this.priceEl = this.querySelector('[data-variant-price]');
      this.submitButton = this.querySelector('[type="submit"]');

      if (this.select) {
        this.select.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    onVariantChange() {
      const option = this.select.selectedOptions[0];

      if (!option) return;

      if (this.priceEl && option.dataset.price) {
        this.priceEl.textContent = option.dataset.price;
      }

      if (!this.submitButton) return;

      const available = option.dataset.available === 'true';
      this.submitButton.disabled = !available;

      if (!option.dataset.buttonLabel) return;

      const buttonContent = this.submitButton.querySelector('button-content');

      if (buttonContent) {
        buttonContent.textContent = option.dataset.buttonLabel;

        if (buttonContent.hasAttribute('rotated-text')) {
          buttonContent.setAttribute('rotated-text', option.dataset.buttonLabel);
        }

        if (buttonContent.hasAttribute('up-text')) {
          buttonContent.setAttribute('up-text', option.dataset.buttonLabel);
        }
      }
    }
  }

  customElements.define('product-card-alt', ProductCardAlt);
}
